import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { patchApiData } from "../helpers/AxiosInstance";
import { AxiosResponse } from "axios";
import { ParseError } from "../helpers/ParseError";

interface Props {
  queryKey: string[];
  navigateURL?: string | null;
}

const usePatchHook = <T extends AxiosResponse>({
  queryKey,
  navigateURL = null,
}: Props) => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const {
    isPending: isLoading,
    mutateAsync,
    isSuccess,
    data,
    isError,
  } = useMutation({
    mutationFn: patchApiData<T>,
    onSuccess: (data: T) => {
      toast.success("Updated successfully");
      if (navigateURL) {
        return navigate(navigateURL);
      }
      return data;
    },
    onError: (error, variables) => {
      const { setError } = variables;
      if (setError && !(error instanceof ParseError)) {
        //@ts-ignore
        for (const key in error?.response?.data) {
          //@ts-ignore
          if (error.response?.data.hasOwnProperty(key)) {
            if (setError)
              setError(key as any, {
                type: "custom",
                //@ts-ignore
                message: error?.response?.data[key],
              });
          }
        }
      }
      throw error;
    },
    onSettled: () => {
      queryClient.invalidateQueries();
    },
  });

  return {
    isLoading,
    mutateAsync,
    isSuccess,
    data,
    isError,
  };
};

export default usePatchHook;
